var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretBreadcrumb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.09609 5.22108L3.97109 8.34608C3.94206 8.37512 3.90759 8.39815 3.86965 8.41386C3.83172 8.42958 3.79106 8.43766 3.75 8.43766C3.70894 8.43766 3.66828 8.42958 3.63034 8.41386C3.59241 8.39815 3.55794 8.37512 3.5289 8.34608C3.49987 8.31705 3.47684 8.28258 3.46113 8.24465C3.44541 8.20671 3.43732 8.16605 3.43732 8.12499C3.43732 8.08393 3.44541 8.04327 3.46113 8.00534C3.47684 7.9674 3.49987 7.93293 3.5289 7.9039L6.4332 4.99999L3.5289 2.09608C3.47027 2.03745 3.43732 1.95792 3.43732 1.87499C3.43732 1.79206 3.47027 1.71253 3.5289 1.6539C3.58754 1.59526 3.66707 1.56232 3.75 1.56232C3.83292 1.56232 3.91245 1.59526 3.97109 1.6539L7.09609 4.7789C7.12515 4.80792 7.1482 4.84238 7.16392 4.88032C7.17965 4.91826 7.18774 4.95892 7.18774 4.99999C7.18774 5.04106 7.17965 5.08172 7.16392 5.11966C7.1482 5.1576 7.12515 5.19206 7.09609 5.22108Z",
    fill: "#142952"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretBreadcrumb);
export default __webpack_public_path__ + "static/media/CaretBreadcrumb.8f5fa688ddad7bb446292e18c76652d1.svg";
export { ForwardRef as ReactComponent };